import { useLingui } from "@lingui/react";
import type { Language } from "@reactive-resume/utils";
import { useQuery } from "@tanstack/react-query";

import { LANGUAGES_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";

export const fetchLanguages = async () => {
  const response = await axios.get<Language[]>(`/translation/languages`);

  return response.data;
};

export const useLanguages = () => {
  const { i18n } = useLingui();
  const {
    error,
    isPending: loading,
    data: languages,
  } = useQuery({
    queryKey: [LANGUAGES_KEY],
    queryFn: fetchLanguages,
  });

  const displayNames = new Intl.DisplayNames([i18n.locale || "fr-FR"], { type: "language" });
  const localizedLanguages = (languages ?? []).map((language) => ({
    ...language,
    name: displayNames.of(language.locale) ?? language.name,
  }));

  return { languages: localizedLanguages, loading, error };
};
